// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__216uH","pendingPaymentIcon":"CalendarEvent_pendingPaymentIcon__1Z6qM","gfeWrapper":"CalendarEvent_gfeWrapper__3lf1K"};